import SalonBusinessCpaTopicPage from "./SalonBusinessCpaTopicPage";

export default function SalonBusinessCpaFinancialStatements() {
  return (
    <SalonBusinessCpaTopicPage
      title="Financial statements"
      description="Prepare clean salon records for income statements, balance sheets, and owner review."
      sections={[
        {
          title: "Income statement",
          body: "Review the salon's sales and expenses by period.",
          items: ["Service revenue", "Product revenue", "Operating expenses"],
        },
        {
          title: "Balance sheet",
          body: "Organize assets, liabilities, and owner amounts.",
          items: ["Bank balances", "Loans and leases", "Owner or shareholder balances"],
        },
        {
          title: "Owner review",
          body: "Use the statements to support better business decisions.",
          items: ["Monthly profit review", "Cash flow notes", "Tax planning questions"],
        },
      ]}
    />
  );
}
